// src/components/select/use-popper.ts
import { useCallback, useEffect, useState } from "react";
var OFFSET = 4;
function usePopper(ref, { open }) {
  const [styles, setPos] = useState(() => {
    const anchorPosition = ref.current?.getBoundingClientRect() ?? null;
    if (!anchorPosition) {
      return { top: OFFSET, left: 0, minWidth: 0 };
    }
    const _top = `${anchorPosition.top + anchorPosition.height + OFFSET}px`;
    const _left = `${anchorPosition.left}px`;
    return { top: _top, left: _left, minWidth: `${anchorPosition.width}px` };
  });
  const recalculatePosition = useCallback(() => {
    const anchorPosition = ref.current?.getBoundingClientRect() ?? null;
    if (!anchorPosition) {
      return { top: 0, left: 0, minWidth: 0 };
    }
    setPos({
      top: `${anchorPosition.top + anchorPosition.height + OFFSET}px`,
      left: `${anchorPosition.left}px`,
      minWidth: `${anchorPosition.width}px`
    });
  }, [ref]);
  useEffect(() => {
    if (!open) return;
    recalculatePosition();
  }, [open, recalculatePosition]);
  useEffect(() => {
    if (!open) return;
    const controller = new AbortController();
    window.addEventListener("resize", recalculatePosition, {
      signal: controller.signal
    });
    document.addEventListener("scroll", recalculatePosition, {
      signal: controller.signal
    });
    return () => {
      controller.abort();
    };
  }, [open, recalculatePosition]);
  return {
    styles: {
      ...styles,
      position: "fixed"
    }
  };
}
export {
  usePopper
};
